module.exports = __webpack_public_path__ + "img/open.d0669dd9.svg";